<template>
<div>
  <div class="wrapper">
    <div id="formContent">
      <div class="fadeIn first">
        <h1>Registration Form</h1>
      </div>
      <input type="text" id="email" class="fadeIn second" name="email" placeholder="E-mail" v-model="email">
      <input type="text" id="name" class="fadeIn third" name="name" placeholder="Name" v-model="name">
      <input type="text" id="username" class="fadeIn fourth" name="username" placeholder="Username" v-model="username">
      <input type="password" id="password" class="fadeIn fifth" name="password" placeholder="Password" v-model="password">
      <input type="password" id="password2" class="fadeIn sixth" name="password2" placeholder="Repeat password" v-model="password2">
      <input type="submit" class="fadeIn seventh" value="Register" @click="doRegister">
      <div v-if="error" class="fadeIn error-message"><span>{{errorMessage}}</span></div>
      <div id="formFooter">
        <router-link class="underlineHover" to="/login">Login</router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'RegisterPage',
  data(){
    return { 
      email: "",
      username: "",
      name: "",
      password: "",
      password2: "",
      error: false,
      errorMessage: ""
    }
  },
  mounted(){
    if(this.$API.loggedIn){
      this.$router.push("/");
      return;
    }
  },
  methods:{
  	doRegister:async function(){
      if(this.password!=this.password2){
        this.errorMessage="Passwords do not match!";
        this.error=true;
        return;
      }
      let response=await this.$API.apiPOST("/register", 
        {
          email: this.email,
          username: this.username,
          name: this.name,
          password: this.password
        }
      );
      if(response.status=="fail"){
        this.errorMessage=response.message;
        this.error=true;
      }else{
        this.$router.push("/registration-success");
      }
    }
  },
  watch:{
    email:function(){
      this.error=false;
    },
    username:function(){
      this.error=false;
    },
    password:function(){
      this.error=false;
    },
    password2:function(){
      this.error=false;
    }
  }
}
</script>